import { Flex, Image, Link } from '@chakra-ui/react'
import React, { VFC } from 'react'

export const Footer: VFC = () => {
  return (
    <Flex
      as={'footer'}
      w={'100%'}
      backgroundColor={'#23651C'}
      borderTop={'1px solid #596e94'}
      justifyContent={'center'}
      align={'center'}
      py={2}
    >
      <Link href={"https://www.hokudai.ac.jp/"}>
        <Image src={`${import.meta.env.BASE_URL}footer-logo.png`} alt={'北海道大学'} height={"40px"}/>
      </Link>
    </Flex>
  )
}
